import {Conversation} from '@stripe-internal/conversations-client';
import {ContentDataRequestIssueContext} from '@stripe-internal/conversations-shared-dependencies';
import {UniversalHelpConversationContext} from '../Providers/ClientProvider/UHLiveChannelsClient';
import {buildTranscript} from './buildTranscript';

export type UHIssueContext = ContentDataRequestIssueContext;

export const buildUHConversationIssueContext = (
  conversation: Conversation,
): UHIssueContext => {
  const uhContext = conversation.context.universalHelp as
    | UniversalHelpConversationContext
    | undefined;

  const issueContext: UHIssueContext = {
    articlesVisited: uhContext?.articlesVisited
      ? Object.keys(uhContext.articlesVisited)
      : [],
    icTagsEncountered: [],
    transcript: buildTranscript(conversation),
  };

  return issueContext;
};
